const translations = {
  es: {
    nav: { services: "Tratamientos", tour: "Instalaciones", team: "Equipo", reviews: "Opiniones", contact: "Contacto" },
    hero: {
      title: "Clínica Dental",
      highlight: "Brandt-Lafuente",
      subtitle: "Clínica dental de confianza en Barcelona con más de 25 años cuidando de nuestros pacientes más allá de sus dientes",
      cta: "Pide tu Cita",
      experience: "+25 años",
      experienceText: "de experiencia profesional",
    },
    services: {
      title: "Nuestros Tratamientos",
      subtitle: "Soluciones dentales integrales con tecnología de vanguardia",
      items: [
        { name: "Odontología General", desc: "Cuidado integral de tu salud dental con tratamientos preventivos y restauradores de la más alta calidad." },
        { name: "Prostodoncia", desc: "Prótesis fija y removible. Prótesis sobre implantes." },
        { name: "Ortopedia y Ortodoncia", desc: (<>Aparatología fija (brackets) y ortodoncia invisible (Certificación Invisalign, Suresmile, Forestadent).<br />Ortopedia funcional maxilar.<br />RNO (Rehabilitación Neuro Oclusal).<br />Niños y adultos.</>) },
        { name: "Estética Dental y Orofacial", desc: "Laminados cerámicos, blanqueamiento dental y ácido hialurónico." },
        { name: "Implantología", desc: (<>Cirugía guiada.<br />PRFG (Plasma rico en factores de crecimiento).<br />Implantes de primeras marcas.</>) },
        { name: "Endodoncia", desc: "Tratamientos de conducto con tecnología avanzada." },
        { name: "Periodoncia", desc: (<>Cuidado especializado de encías y tejidos de soporte.<br />Cirugía mucogingival.</>) },
        { name: "Disfunción Craneomandibular", desc: (<>Estudio oclusión y de ATM.<br />Condilografía electrónica.<br />Tratamiento del bruxismo.</>) },
        { name: "Ronquido y Apneas", desc: "Dispositivos de avance mandibular (DAM)." },
        { name: "Formación Holística", desc: "Terapia neural, kinesiología médica aplicada y BEMER." },
      ],
    },
    tour: {
      title: "Conoce Nuestras Instalaciones",
      description: "Descubre nuestra clínica como si ya estuvieras dentro.",
    },
    team: {
      title: "Nuestro Equipo",
      members: [
        { name: "Dr. Rainer Brandt", role: "Médico y Odontólogo", desc: "Nº Col. COMB 27.787 / COEC 2.462" },
        { name: "Dra. Pilar Lafuente", role: "Médico y Odontólogo", desc: "Nº Col. COMB 29.205 / COEC 2.541" },
        { name: "Eva, Montse y Alex", role: "Equipo de Auxiliares" },
      ],
    },
    whyUs: {
      title: "¿Por Qué Elegirnos?",
      items: [
        { value: 25, suffix: "+", label: "Años de Experiencia", desc: "Más de dos décadas cuidando sonrisas en Barcelona" },
        { value: 100, suffix: "%", label: "Profesionalidad", desc: "Equipo altamente cualificado y en constante formación" },
        { value: 4.8, suffix: "", label: "Valoración Google", desc: "Trato cercano y soluciones adaptadas a cada paciente" },
        {
          value: 0,
          suffix: "",
          label: "Tecnología Avanzada",
          desc: (<>Equipamiento de última generación.<br />Odontología digital.</>),
          isIcon: true,
          icon: "tech",
        },
        {
          value: 0,
          suffix: "",
          label: "Idiomas",
          desc: (<>Además de Castellano y Catalán, atendemos en Inglés y Alemán.</>),
          isIcon: true,
          icon: "languages",
        },
      ],
    },
    reviews: {
      title: "Lo Que Dicen Nuestros Pacientes",
      basedOn: "Basado en reseñas de Google",
      viewAll: "Ver todas las reseñas en Google",
    },
    schedule: {
      title: "Horario de Atención",
      days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"],
      emergency: "Intentamos atender urgencias el mismo día",
      emergencyNote: "Previa concertación telefónica",
    },
    contact: {
      title: "Contacto y Ubicación",
      address: "Dirección",
      phone: "Teléfono",
      whatsapp: "WhatsApp",
      whatsappDesc: "Chatea con nosotros haciendo clic en el botón verde flotante",
      transport: "Transporte Público",
      transportLine1: "FFCC: L7 (Paradas Plaza Kennedy o Putxet)",
      transportLine2: "Bus: Líneas H4, H6, V13, V15",
    },
    footer: { rights: "Todos los derechos reservados" },
    whatsappMsg: "Hola, me gustaría solicitar información sobre los servicios de la clínica",
  },

  cat: {
    nav: { services: "Tractaments", tour: "Instal·lacions", team: "Equip", reviews: "Opinions", contact: "Contacte" },
    hero: {
      title: "Clínica Dental",
      highlight: "Brandt-Lafuente",
      subtitle: "Clínica dental de confiança a Barcelona amb més de 25 anys cuidant dels nostres pacients més enllà de les seves dents",
      cta: "Demana Cita",
      experience: "+25 anys",
      experienceText: "d'experiència professional",
    },
    services: {
      title: "Els Nostres Tractaments",
      subtitle: "Solucions dentals integrals amb tecnologia d'avantguarda",
      items: [
        { name: "Odontologia General", desc: "Cura integral de la teva salut dental amb tractaments preventius i restauradors de la més alta qualitat." },
        { name: "Prostodòncia", desc: "Pròtesi fixa i removible. Pròtesi sobre implants." },
        { name: "Ortopèdia i Ortodòncia", desc: (<>Aparells fixos (brackets) i ortodòncia invisible (certificació Invisalign, Suresmile, Forestadent).<br />Ortopèdia funcional maxil·lar.<br />RNO (Rehabilitació Neuro Oclusal).<br />Infants i adults.</>) },
        { name: "Estètica Dental i Orofacial", desc: "Laminats ceràmics, blanquejament dental i àcid hialurònic." },
        { name: "Implantologia", desc: (<>Cirurgia guiada.<br />PRFG (Plasma ric en factors de creixement).<br />Implants de primeres marques.</>) },
        { name: "Endodòncia", desc: "Tractaments de conducte amb tecnologia avançada." },
        { name: "Periodòncia", desc: (<>Cura especialitzada de genives i teixits de suport.<br />Cirurgia mucogingival.</>) },
        { name: "Disfunció Craneomandibular", desc: (<>Estudi de l’oclusió i de l’ATM.<br />Condilografia electrònica.<br />Tractament del bruxisme.</>) },
        { name: "Ronc i Apnees", desc: "Dispositius d'avanç mandibular (DAM)." },
        { name: "Formació Holística", desc: "Teràpia neural, kinesiologia mèdica aplicada i BEMER." },
      ],
    },
    tour: {
      title: "Coneix les Nostres Instal·lacions",
      description: "Descobreix la nostra clínica com si ja hi fossis dins.",
    },
    team: {
      title: "El Nostre Equip",
      members: [
        { name: "Dr. Rainer Brandt", role: "Metge i Odontòleg", desc: "Nº Col. COMB 27.787 / COEC 2.462" },
        { name: "Dra. Pilar Lafuente", role: "Metge i Odontòleg", desc: "Nº Col. COMB 29.205 / COEC 2.541" },
        { name: "Eva, Montse i Alex", role: "Equip d’Auxiliars" },
      ],
    },
    whyUs: {
      title: "Per Què Escollir-nos?",
      items: [
        { value: 25, suffix: "+", label: "Anys d'Experiència", desc: "Més de dues dècades cuidant somriures a Barcelona" },
        { value: 100, suffix: "%", label: "Professionalitat", desc: "Equip altament qualificat i en constant formació" },
        { value: 4.8, suffix: "", label: "Valoració Google", desc: "Tracte proper i solucions adaptades a cada pacient" },
        {
          value: 0,
          suffix: "",
          label: "Tecnologia Avançada",
          desc: (<>Equipament d'última generació.<br />Odontologia digital.</>),
          isIcon: true,
          icon: "tech",
        },
        {
          value: 0,
          suffix: "",
          label: "Idiomes",
          desc: (<>A més de Castellà i Català, atenem en Anglès i Alemany.</>),
          isIcon: true,
          icon: "languages",
        },
      ],
    },
    reviews: {
      title: "El Que Diuen els Nostres Pacients",
      basedOn: "Basat en ressenyes de Google",
      viewAll: "Veure totes les ressenyes a Google",
    },
    schedule: {
      title: "Horari d'Atenció",
      days: ["Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres"],
      emergency: "Intentem atendre urgències el mateix dia",
      emergencyNote: "Prèvia concertació telefònica",
    },
    contact: {
      title: "Contacte i Ubicació",
      address: "Adreça",
      phone: "Telèfon",
      whatsapp: "WhatsApp",
      whatsappDesc: "Xateja amb nosaltres fent clic al botó verd flotant",
      transport: "Transport Públic",
      transportLine1: "FFCC: L7 (Parades Plaça Kennedy o Putxet)",
      transportLine2: "Bus: Línies H4, H6, V13, V15",
    },
    footer: { rights: "Tots els drets reservats" },
    whatsappMsg: "Hola, m'agradaria sol·licitar informació sobre els serveis de la clínica",
  },

  en: {
    nav: { services: "Treatments", tour: "Facilities", team: "Team", reviews: "Reviews", contact: "Contact" },
    hero: {
      title: "Dental Clinic",
      highlight: "Brandt-Lafuente",
      subtitle: "Trusted dental clinic in Barcelona with over 25 years caring for our patients beyond their teeth",
      cta: "Book Appointment",
      experience: "+25 years",
      experienceText: "of professional experience",
    },
    services: {
      title: "Our Treatments",
      subtitle: "Comprehensive dental solutions with cutting-edge technology",
      items: [
        { name: "General Dentistry", desc: "Comprehensive dental care with preventive and restorative treatments of the highest quality." },
        { name: "Prosthodontics", desc: "Fixed and removable prosthetics. Implant-supported prostheses." },
        { name: "Orthopedics & Orthodontics", desc: (<>Fixed appliances (braces) and invisible orthodontics (Invisalign, Suresmile, Forestadent certified).<br />Functional maxillary orthopedics.<br />NOR (Neuro-Occlusal Rehabilitation).<br />Children and adults.</>) },
        { name: "Dental & Orofacial Aesthetics", desc: "Ceramic veneers, teeth whitening, and hyaluronic acid treatments." },
        { name: "Implantology", desc: (<>Guided surgery.<br />PRFG (Plasma Rich in Growth Factors).<br />Premium-brand implants.</>) },
        { name: "Endodontics", desc: "Root canal treatments with advanced technology." },
        { name: "Periodontics", desc: (<>Specialized care for gums and supporting tissues.<br />Mucogingival surgery.</>) },
        { name: "Craniomandibular Dysfunction", desc: (<>Occlusion and TMJ assessment.<br />Electronic condylography.<br />Bruxism treatment.</>) },
        { name: "Snoring & Sleep Apnea", desc: "Mandibular advancement devices (MAD)." },
        { name: "Holistic Approach", desc: "Neural therapy, applied medical kinesiology, and BEMER." },
      ],
    },
    tour: {
      title: "Explore Our Facilities",
      description: "Discover our clinic as if you were already inside.",
    },
    team: {
      title: "Our Team",
      members: [
        { name: "Dr. Rainer Brandt", role: "Medical Doctor & Dentist", desc: "Col. N. COMB 27.787 / COEC 2.462" },
        { name: "Dr. Pilar Lafuente", role: "Medical Doctor & Dentist", desc: "Col. N. COMB 29.205 / COEC 2.541"  },
        { name: "Eva, Montse & Alex", role: "Dental Assistants Team" },
      ],
    },
    whyUs: {
      title: "Why Choose Us?",
      items: [
        { value: 25, suffix: "+", label: "Years of Experience", desc: "Over two decades caring for smiles in Barcelona" },
        { value: 100, suffix: "%", label: "Professionalism", desc: "Highly qualified team in constant training" },
        { value: 4.8, suffix: "", label: "Google Rating", desc: "Close treatment and solutions tailored to each patient" },
        {
          value: 0,
          suffix: "",
          label: "Advanced Technology",
          desc: (<>State-of-the-art equipment.<br />Digital dentistry.</>),
          isIcon: true,
          icon: "tech",
        },
        {
          value: 0,
          suffix: "",
          label: "Languages",
          desc: (<>In addition to Spanish and Catalan, we also assist in English and German.</>),
          isIcon: true,
          icon: "languages",
        },
      ],
    },
    reviews: {
      title: "What Our Patients Say",
      basedOn: "Based on Google reviews",
      viewAll: "View all reviews on Google",
    },
    schedule: {
      title: "Opening Hours",
      days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      emergency: "We try to attend emergencies the same day",
      emergencyNote: "By prior phone arrangement",
    },
    contact: {
      title: "Contact & Location",
      address: "Address",
      phone: "Phone",
      whatsapp: "WhatsApp",
      whatsappDesc: "Chat with us by clicking the green floating button",
      transport: "Public Transport",
      transportLine1: "FFCC: L7 (Plaza Kennedy or Putxet stops)",
      transportLine2: "Bus: Lines H4, H6, V13, V15",
    },
    footer: { rights: "All rights reserved" },
    whatsappMsg: "Hello, I would like to request information about the clinic's services",
  },

  de: {
    nav: { services: "Behandlungen", tour: "Einrichtungen", team: "Team", reviews: "Bewertungen", contact: "Kontakt" },
    hero: {
      title: "Zahnklinik",
      highlight: "Brandt-Lafuente",
      subtitle: "Vertrauenswürdige Zahnklinik in Barcelona mit über 25 Jahren Erfahrung in der Betreuung unserer Patienten über ihre Zähne hinaus",
      cta: "Termin Vereinbaren",
      experience: "+25 Jahre",
      experienceText: "Berufserfahrung",
    },
    services: {
      title: "Unsere Behandlungen",
      subtitle: "Umfassende zahnmedizinische Lösungen mit modernster Technologie",
      items: [
        { name: "Allgemeine Zahnheilkunde", desc: "Umfassende Zahnpflege mit präventiven und restaurativen Behandlungen höchster Qualität." },
        { name: "Prothetik", desc: "Fester und herausnehmbarer Zahnersatz. Implantatgetragene Prothesen." },
        { name: "Orthopädie & Kieferorthopädie", desc: (<>Feste Apparaturen (Brackets) und unsichtbare Kieferorthopädie (zertifiziert für Invisalign, Suresmile, Forestadent).<br />Funktionelle Kieferorthopädie.<br />NOR (Neurookklusale Rehabilitation).<br />Kinder und Erwachsene.</>) },
        { name: "Zahnästhetik & Orofaziale Ästhetik", desc: "Keramikveneers, Zahnaufhellung und Hyaluronsäure-Behandlungen." },
        { name: "Implantologie", desc: (<>Geführte Chirurgie.<br />PRFG (Plasma reich an Wachstumsfaktoren).<br />Implantate führender Marken.</>) },
        { name: "Endodontie", desc: "Wurzelkanalbehandlungen mit fortschrittlicher Technologie." },
        { name: "Parodontologie", desc: (<>Spezialisierte Pflege von Zahnfleisch und Stützgewebe.<br />Mukogingivale Chirurgie.</>) },
        { name: "Kraniomandibuläre Dysfunktion", desc: (<>Untersuchung von Okklusion und Kiefergelenke (TMJ).<br />Elektronische Kondylographie.<br />Behandlung von Bruxismus.</>) },
        { name: "Schnarchen & Schlafapnoe", desc: "Unterkieferprotrusionsschienen (MAD)." },
        { name: "Ganzheitlicher Ansatz", desc: "Neuraltherapie, angewandte medizinische Kinesiologie und BEMER." },
      ],
    },
    tour: {
      title: "Unsere Einrichtungen",
      description: "Erfahren Sie unsere Klinik, als wären Sie schon dort.",
    },
    team: {
      title: "Unser Team",
      members: [
        { name: "Dr. Rainer Brandt", role: "Arzt und Zahndrzt", desc: "Col. N. COMB 27.787 / COEC 2.462" },
        { name: "Dr. Pilar Lafuente", role: "Arzt und Zahndrzt", desc: "Col. N. COMB 29.205 / COEC 2.541"  },
        { name: "Eva, Montse & Alex", role: "Zahwarzthelferinnen" },
      ],
    },
    whyUs: {
      title: "Warum Sollten Sie uns wählen?",
      items: [
        { value: 25, suffix: "+", label: "Jahre Erfahrung", desc: "Schon über zwei Jahrzehnte kümmern wir uns um ein schönes und gesundes Lachen" },
        { value: 100, suffix: "%", label: "Professionalität", desc: "Hochqualifiziertes Team in ständiger Weiterbildung" },
        { value: 4.8, suffix: "", label: "Google-Bewertung", desc: "Einfühlsame Betreuung und individuell angepasste Lösungen" },
        {
          value: 0,
          suffix: "",
          label: "Fortschrittliche Technologie",
          desc: (<>Modernste Ausstattung.<br />Digitale Zahnmedizin.</>),
          isIcon: true,
          icon: "tech",
        },
        {
          value: 0,
          suffix: "",
          label: "Sprachen",
          desc: (<>Neben Spanisch und Katalanisch betreuen wir Sie auch auf Englisch und Deutsch.</>),
          isIcon: true,
          icon: "languages",
        },
      ],
    },
    reviews: {
      title: "Was unsere Patienten sagen",
      basedOn: "Basierend auf Google-Bewertungen",
      viewAll: "Alle Bewertungen auf Google ansehen",
    },
    schedule: {
      title: "Öffnungszeiten",
      days: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag"],
      emergency: "Wir versuchen Notfälle am selben Tag zu behandeln",
      emergencyNote: "Nach vorheriger telefonischer Vereinbarung",
    },
    contact: {
      title: "Kontakt & Standort",
      address: "Adresse",
      phone: "Telefon",
      whatsapp: "WhatsApp",
      whatsappDesc: "Chatten Sie mit uns über den grünen Button",
      transport: "Öffentliche Verkehrsmittel",
      transportLine1: "FFCC: L7 (Haltestellen Plaza Kennedy oder Putxet)",
      transportLine2: "Bus: Linien H4, H6, V13, V15",
    },
    footer: { rights: "Alle Rechte vorbehalten" },
    whatsappMsg: "Hallo, ich möchte Informationen über die Leistungen der Klinik anfragen",
  },
};

export default translations;